<template>
  <div>
    <vs-popup :title="$t('Details')" :active.sync="showModal">
      <div class="flex flex-col gap-1">
        <span class="font-bold">گارانتی اصلی</span>
        <vs-table :data="[mainWarranty]" class="custom-tbl">
          <template slot="thead">
            <th>{{ $t("WarrantyDuration") }}</th>
            <th>{{ $t("WarrantyItemType") }}</th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(tr, i) in data">
              <vs-td style="width: 50%">
                {{ tr.guarantyDuration }}
              </vs-td>
              <vs-td style="width: 50%">
                {{ tr.mainWarrantyItemType }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <span class="font-bold">لیست گارانتی‌های ثانویه</span>
        <vs-table :data="alternativeWarrantyItems" class="custom-tbl">
          <template slot="thead">
            <th>#</th>
            <th>{{ $t("WarrantyDuration") }}</th>
            <th>{{ $t("AlternativeWarrantyItemType") }}</th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(tr, i) in data">
              <vs-td style="width: 5%">
                {{ i + 1 }}
              </vs-td>
              <vs-td style="width: 45%">
                {{ tr.guarantyDuration }}
              </vs-td>
              <vs-td style="width: 50%">
                {{ tr.alternativeWarrantyItemType }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
.vs-con-input input {
  text-align: right;
}
.custom-tbl td {
  padding: 0.5rem 1rem !important;
}
</style>
<script>
export default {
  name: "",
  props: {
    show: { default: false },
    alternativeWarrantyItems: { default: [] },
    mainWarranty: { default: {} },
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
};
</script>
